import { useGetDomainGymQuery, useGetGymWorkoutsQuery, useGetScheduledStreamsQuery } from "store/api/api";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { Flex, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { updateSelectedMuxVideoUrl, updateSelectedWorkout } from "store/slices";
import { useDispatch } from "react-redux";
import LiveWorkoutCard from "./LiveWorkoutCard";
import GoLive from "./GoLive";
import { EditWorkoutModal } from "components/Modals/EditWorkoutModal";
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);

const StartingSoon = () => {
	const { gym } = useParams();
	const dispatch = useDispatch();
	const domainGymResponse = useGetDomainGymQuery(gym);
	const domainGymId = domainGymResponse?.data?.id;
	const { data: scheduledStreams, refetch: refetchStreams } = useGetScheduledStreamsQuery(domainGymId, {
		skip: !domainGymResponse.data,
	});
	const workoutsResponse = useGetGymWorkoutsQuery({ gym_id: domainGymId }, { skip: !domainGymResponse.data });
	const [showEditWorkoutModal, setShowEditWorkoutModal] = useState(false);
	const [selectedLiveStream, setSelectedLiveStream] = useState(null);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const liveWorkouts = workoutsResponse.data?.workouts?.filter((workout) => !!workout.start_time) || [];
	const streamsToShow = scheduledStreams
		?.map((stream) => {
			const match = liveWorkouts.find((workout) => workout.id === stream.workout_id);
			return match && { ...stream, ...match };
		})
		.filter(Boolean)
		.sort((a, b) => {
			const isAfter = dayjs.tz(a.start_time, a.time_zone).isAfter(dayjs.tz(b.start_time, b.time_zone));
			if (isAfter) return 1;
			else return -1;
		});

	const onEditSetVisible = (bool, workout) => {
		if (workout) {
			dispatch(updateSelectedWorkout({ workout }));
			setSelectedLiveStream(workout);
		}
		setShowEditWorkoutModal(bool);
		if (!bool) {
			dispatch(updateSelectedWorkout({ workout: null }));
			dispatch(updateSelectedMuxVideoUrl({ url: null }));
		}
	};
	const scheduledStreamsData = streamsToShow?.filter((stream) => {
		const match = liveWorkouts.find((workout) => workout.id === stream.workout_id);
		const duration = Math.ceil((match?.duration || 0) / 60);
		const endTime = dayjs.tz(stream.start_time, stream.time_zone).add(duration, "minutes");
		const startTime = dayjs.tz(stream.start_time, stream.time_zone);
		return !(!match || endTime.isBefore(dayjs()) || startTime.isAfter(dayjs().add(24, "hours")));
	});
	return (
		<Flex vertical style={{ marginBottom: 24, width: "100%" }} gap={16}>
			{streamsToShow &&
				[...streamsToShow].reverse().map((stream, i) => {
					const match = liveWorkouts.find((workout) => workout.id === stream.workout_id);
					const duration = Math.ceil((match?.duration || 0) / 60);
					const endTime = dayjs.tz(stream.start_time, stream.time_zone).add(duration, "minutes");
					const startTime = dayjs.tz(stream.start_time, stream.time_zone);
					if (!match || endTime.isBefore(dayjs()) || startTime.isAfter(dayjs().add(24, "hours"))) return null;
					const durationInMinutes = Math.ceil(match.duration / 60);
					return (
						<LiveWorkoutCard
							key={stream?.workout_id}
							image={match?.image_url || "https://via.placeholder.com/130x80"}
							workoutName={match.name}
							categories={match.categories}
							dateTime={`${dayjs
								.tz(match.start_time, match.time_zone)
								.format("MMMM D, YYYY | h:mm A z")} | ${durationInMinutes} Mins`}
							musicGenre={match.music_genre}
							streamKey={stream.mux_stream_key}
							onGoLiveClick={() => dispatch(updateSelectedWorkout({ workout: { ...match, ...stream } }))}
							onEditClick={() => onEditSetVisible(true, match)}
							refetchStreams={refetchStreams}
							workout={{ ...match, ...stream }}
						/>
					);
				})}
			{!scheduledStreamsData?.length && (
				<Flex className="no-scheduled-live-streams" align="center" justify="center" gap={8}>
					<InfoCircleOutlined style={{ color: "rgb(23, 119, 255)" }} />
					<Typography.Paragraph style={{ fontSize: 16 }}>
						You don't have any livestreams scheduled in the next 24 hours.
					</Typography.Paragraph>
				</Flex>
			)}
			<EditWorkoutModal
				open={showEditWorkoutModal}
				setOpen={onEditSetVisible}
				isEditingLive
				liveStream={selectedLiveStream}
				onClose={() => workoutsResponse?.refetch?.()}
			/>
			<GoLive open={isModalVisible} closeModal={() => setIsModalVisible(false)} refetchStreams={refetchStreams} />
		</Flex>
	);
};

export default StartingSoon;

